export default __webpack_public_path__ + "static/media/delta.a4be58f2.webp";